import { InjectionToken } from '@angular/core';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils';
export const AJSUtilstServiceToken = new InjectionToken<any> ('Utils');
export const AJSUtilstServiceTokenProvider = upgradeAJSServiceProvider( 'UtilsService', AJSUtilstServiceToken );
export interface SelectedSegmentsType {
    isAllowed: boolean;
    newSegmentsId: any[];
    checkablePassengers: any[];
}
export interface SeatMapType {
    type: any;
    segments: any[];
}
export interface InhibitReasonType {
    SEE_AGENT: boolean;
    AIRCHECK: boolean;
    BOKO: boolean;
    INHIBIT: boolean;
    RESI: boolean;
    UMNR: boolean;
    AVIH: boolean;
    PETC: boolean;
    COUR: boolean;
}
export interface UtilsServiceType {
    getDeviceType: () => any;
    getAuthToken: () => any;
    Base64Decode: ( str, utf8decode ) => any;
    getParameterByName: ( name, url ) => string | null;
    getPathParameterByName: ( name ) => string | null;
    getTravelAgencies: ( name ) => string;
    getReInvoicing: ( parameter: string ) => any;
    generatePassengersQueryString: ( passengersId ) => string;
    getPassengersInfo: ( passengersInfo ) => any;
    filterAdditionalInfo: ( bookingInfo, additionalInfoData ) => any;
    setFareFamilyConditions: ( fareFamilyInfo ) => any;
    generateBuildNumberQueryString: () => string;
    checkPendingPayments: ( bookingInfo ) => boolean;
    checkFailedPendingPayments: ( cancelData ) => any;
    getCachedSelectedInfo: ( cachedData ) => any[];
    getCabinClassName: ( cabinClassType ) => string;
    isValidPassengerStatus: ( pasStatus ) => boolean;
    getTripSegments: ( idSegments, cachedInfo ) => any[];
    getMarketLabel: () => string;
    getSSOErrorCodeMessage: () => string;
    isPassengerSelected: () => boolean;
    validLuhnCompanyCard: ( ccNum ) => boolean;
    updateSegmentCabinClass: ( segmentId, cabinClassType ) => void;
    initStorage: () => void;
    checkConfirmationPNR: () => string;
    saveEndpoints: ( endpointsData ) => void;
    getEndpoint: ( key ) => any;
    getMetaTagValueByName: ( metaTagName ) => string;
    getAirlineLogos: () => any;
    updateSelectedSegments: ( selectedSegment, newBookingInfo ) => SelectedSegmentsType;
    updateCachedInfo: ( acceptData ) => any[];
    isUserLogged: () => boolean;
    cleanSpaces: () => string;
    getSlashDate: ( date ) => string;
    getMiddleDashDate: ( date ) => string;
    generateUpdateSeatsMap: ( updateInfo ) => SeatMapType[];
    updateCachedInformation: ( update, segmentId ) => void;
    getSegmentSeatsPending: () => any;
    updateSegmentSeatStatus: ( passsengersUpdated, segmentId ) => void;
    checkEarlySegments: ( passengers, segmentsSelected ) => boolean;
    checkEarlyFlights: ( bookingInfo, selectedSegments ) => boolean;
    goIbCose: () => void;
    checkCompany: ( company ) => boolean;
    getInfoHeader: ( segments, passengers ) => any[];
    getHeadeUpgradingInfo: ( ancillaries: any[] ) => any;
    getElementsByProperty: ( array, parameter, canBeRepeated ) => any;
    generateHeaderTripsInfo: () => any;
    getSegmentsInfo: () => any[];
    getPaymentsBackGroundURL: () => string;
    setAncillariesCurrency: ( currencies, issueCurrency ) => void;
    warnUserOnBackPressed: ( history, window, location, angular, closeModal ) => void;
    removeParameterURL: ( url ) => any;
    setAncillariesBob: ( freeItems ) => void;
    backToMain: ( event, goToHome, closeSession ) => void;
    setAircraftDatalayer: () => any;
    getAppMarket: () => any;
    getPrefixFromMarket: () => any;
    updateLanguageAdditionalInfo: ( additionalInfo ) => any;
    getAppLang: () => string;
    setTitlePage: ( title, time ) => void;
    showPriorityAlertInhibit: ( items: any[] ) => any;
    checkInhibitReason: ( reasons: any[] ) => InhibitReasonType;
    priorityInhibit: ( reason: any[] ) => string;
    filterMarket: ( market: string ) => string;
    concatUnique: ( array1: any[], array2: any[] ) => any[];
    cleanDataSoftUser: ( value: string) => string;
}
